export const REACT_APP_JWT_TOKEN = "contact-mgr-react-token";